import styled from 'styled-components';
import Box from 'ui/Box';
import media from 'ui/media';

const SheetBox = styled(Box)`
  padding-top: 0;
  padding-right: ${({ theme }) => theme.space.xxl};
  padding-bottom: ${({ theme }) => theme.space.xxl};
  padding-left: ${({ theme }) => theme.space.xxl};
  display: flex;
  align-content: space-between;
  flex-direction: column;
  overflow-y: auto;
  ${media.mobile`
  padding: 0 1.6rem 1.6rem 1.6rem;
`}
`;

export default SheetBox;
